import {createFragmentRegistry} from "@apollo/client/cache";
import {gql} from "graphql-tag";

export function useApolloFragmentLoader() {


    const getFragments     = (fragmentsInFolder) => {

        let fragments     = []

        for(const path in fragmentsInFolder){
            fragments.push(fragmentsInFolder[path].default.loc.source.body)
        }

        return fragments
    }

    const getFragmentRegistry = (fragmentsInFolder) => {

        const fragments     = getFragments(fragmentsInFolder)

        return createFragmentRegistry(gql`${fragments.join('\n\n')}`)
    }

    return {
        getFragmentRegistry,
        getFragments
    }
}